<template>
  <div id="main" aria-label="content">
    <header></header>
    <main>
      <section class="section section--movie">
        <div class="section__inner-wrapper">
          <div class="section__header">
            <breadcrumb :steps="[['Home', '/'], ['Movies']]"/>
            <h1 class="section__title">Movies</h1>
          </div>
          <div v-if="isLoading" class="c-loading c-loading--movies">
            <svg width="100" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="lds-dual-ring" style="background:0 0"><circle cx="50" cy="50" fill="none" stroke-linecap="round" r="40" stroke-width="4" stroke="#363472" stroke-dasharray="62.83185307179586 62.83185307179586" transform="rotate(162.457 50 50)"><animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 50;360 50 50" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"/></circle></svg>
          </div>
          <div class="c-movie" v-else-if="totalPages">
            <movie-item :key="item.id" :item="item" v-for="item in paginatedList"/>
          </div>
          <div v-else-if="error" class="error">
            <div class="c-message__info has-error">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 0a9 9 0 109 9 9.026 9.026 0 00-9-9zm3.713 11.652l-1.061 1.06L9 10.06l-2.652 2.652-1.06-1.06L7.938 9 5.287 6.348l1.061-1.06L9 7.938l2.652-2.652 1.06 1.061L10.06 9l2.652 2.652z" fill="#DF2137"/></svg>
              <span>Error:</span> {{error}}
            </div>
          </div>

          <v-pagination v-if="totalPages>1" v-model="currentPage"
                          :page-count="totalPages"
                          :classes="bootstrapPaginationClasses"
            ></v-pagination>
        </div>
      </section>
    </main>
    <footer></footer>
  </div>
</template>

<script>
  import Vue from 'vue'
  import VueSilentbox from 'vue-silentbox'
  import vPagination from 'vue-plain-pagination'
  import VueLazyload from 'vue-lazyload'
  import Breadcrumb from '@/components/breadcrumb';
  import MovieItem from '@/components/movie-item';

  Vue.use(VueSilentbox)
  Vue.use(VueLazyload)

  export let movieList = [];

  export default {
    name: "Movies",
    data() {
      return {
        mockupJSON : [],
        isLoading : false,
        itemsPerPage: 10,
        currentPage: 1,
        error: '',
        bootstrapPaginationClasses: {
          ul: 'c-pagination',
          li: '',
          liActive: 'is-active',
          liDisable: '',
          button: 'c-link c-link--pagination'
        },
      }
    },
    computed:{
      paginatedList() {
        const list = this.$store.getters['movies/movieList'];
        if (list && list.length > 18) {
          const curPage = this.currentPage - 1;
          const from = curPage * this.itemsPerPage;
          return list.slice(from, Math.min(from + (this.itemsPerPage), list.length));
        }
        return list || [];
      },
      totalPages() {
        const list = this.$store.getters['movies/movieList'];
        if (list && list.length > 18) {
          return list ? Math.ceil(list.length / this.itemsPerPage) : 0;
        }
        return 1;
      }
    },
    components:{
      MovieItem,
      Breadcrumb,
      vPagination
    },
    created(){
      this.$store.dispatch('clearLocalStorage');
      this.isLoading = true;
      this.$store.dispatch('movies/load').catch((err) => {
        this.error = err;
      }).finally(() => {
        this.isLoading = false;
      });
    },
    watch: {
      currentPage : function (val) {
        this.$store.dispatch('scrollTop');
        let meta = {
          func: [
            {call: 'color', modifier: 'temp', argument: '#363472'},
            {call: 'fail', modifier: 'temp', argument: '#6e0000'},
            {call: 'location', modifier: 'temp', argument: 'top'},
            {call: 'transition', modifier: 'temp', argument: {speed: '1.5s', opacity: '0.6s', termination: 400}}
          ]
        };
        this.$Progress.parseMeta(meta);
        this.$Progress.start()
      }
    }
  }

</script>

<style lang="scss" scoped>
  .silentbox-single{
    text-decoration: none;
  }
  .c-link--movie{
    background-color: rgba(0,0,0,.05);
    min-height: 190px;
    border-radius: 6px;
  }
  img[lazy='loaded'] {
    opacity: 0;
    animation-name: fadein;
    animation-duration: .5s;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
    animation-direction: normal;
    animation-timing-function: ease-out;
    @keyframes fadein {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }
  }
</style>
